import { TextEditor } from '@smartgift/frontend-toolkit';
import convert from 'htmr';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { constants } from '@hero/configs';

const Wrapper = styled.div`
  border-radius: var(--size-border-radius-md);
  margin-bottom: 4px;
  margin-top: 4px;
  min-height: 40px;
  width: 100%;

  ${({ isFocused }) =>
    !isFocused &&
    css`
      outline-color: var(--color-border-default);
      transition: all 0.2s ease-in-out;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    `}

  ${TextEditor?.S?.Editor} {
    background-color: var(--color-bg-default);
    margin-top: 12px;

    &:focus {
      border: 1px solid var(--color-accent-primary-default);
    }
  }
`;

const ReadOnlyText = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  overflow: hidden;
`;

function ColumnTextEditor({ isFocused, onChange, readOnly, onFocus, ...props }) {
  return (
    <Wrapper
      onClick={() => {
        !isFocused && onFocus?.();
      }}
      isFocused={isFocused}
    >
      {isFocused && !readOnly ? (
        <TextEditor
          onChange={val => {
            onChange(undefined, val);
          }}
          {...props}
          {...props?.columnProps?.componentProps}
          limit={constants?.general?.giftMessageLimit}
          showCounter
          onBlur={e => {
            if (
              e?.relatedTarget?.nodeName === 'BUTTON' ||
              e?.relatedTarget?.className?.includes('tiptap')
            ) {
              return;
            }

            props?.onBlur?.(e);
          }}
        />
      ) : (
        <ReadOnlyText>{convert(props.value || '')}</ReadOnlyText>
      )}
    </Wrapper>
  );
}

ColumnTextEditor.propTypes = {
  isFocused: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  readOnly: PropTypes.bool
};

export { ColumnTextEditor };
